require('./cardBenefitsBenefitsSection.scss');
const PropTypes = require('prop-types');
//@vendor
const React = require('react');
//@commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
//@utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
//@components
const CardBenefit = require('components/cards/cardBenefits/cardBenefit/cardBenefit');
const { CollectiveTag } = require('components/commons/collectiveTag/collectiveTag');

const TRANSLATION_KEY = 'cardBenefitsBenefitsSection-';

class CardBenefitsBenefitsSection extends React.Component {

    buildBenefits(benefits) {
        const { immCard } = this.props
        return benefits.map((benefit, index) => {
            return (
                <CardBenefit
                    key={`benefit-${index}`}
                    immBenefit={benefit}
                    immCard={immCard}
                />
            );
        });
    }

    buildRows(benefits) {
        return benefits.map((item, index) => {
            const sectionHt = (index === benefits.size - 1 || index === benefits.size - 2) ? "100px":"220px"
            return (
                <div key={`benefit-item-${index}`} className="col-xs-6" style={{height:sectionHt}}>
                    {item}
                </div>
            );
        });
    }

    buildCollectiveTag() {
        const { collectiveAlias, cardType} = this.props;
        const contentKey = {
            'diamond': "hireCardSidebar-collectiveTooltipContentDiamondPack",
            'premium': "contractSummary-collectiveTooltipContent"
        }
        return (
            <CollectiveTag
                extraClass="pull-right"
                productAlias={collectiveAlias}
                tooltipContent={contentKey[cardType]}
            />
        )
    }

    render() {
        const { cardType, immBenefits, immProfile } = this.props;
        const collectiveTagContent = this.buildCollectiveTag();
        const benefits = this.buildBenefits(immBenefits);
        const rows = this.buildRows(benefits);

        const title = formatText(`${TRANSLATION_KEY}title`);

        let sectionSubtitleTransKey  = `${TRANSLATION_KEY}${cardType}Subtitle`;

        if (immProfile.get('isCollective')){
            sectionSubtitleTransKey = (cardType === 'diamond') ? `${TRANSLATION_KEY}collectivosDiamondSubtitle`
                : `${TRANSLATION_KEY}collectivosPremiumSubtitle`;
        }

        return (
            <OKSectionBox>
                <h3 className="new-card-details__title">
                    {title}
                    {collectiveTagContent}
                </h3>
                <header className="card-benefits-benefits-section__header">
                    <div className="card-benefits-benefits-section__subtitle">
                        <FormattedText value={sectionSubtitleTransKey} />
                    </div>
                </header>
                <section className="card-benefits-benefits-section__benefits-section row">
                    {rows}
                </section>
            </OKSectionBox>
        );
    }
}


CardBenefitsBenefitsSection.propTypes = {
    cardType: PropTypes.string,
    collectiveAlias: PropTypes.string,
    immBenefits: PropTypes.object,
    immProfile: PropTypes.object,
    immCard: PropTypes.object,
};

module.exports = CardBenefitsBenefitsSection;
